/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpAuthHelperService } from './http-auth-helper.service';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ShopService {
  private baseUrl = environment.endpoint;

  constructor(
    private httpAuthHelperService: HttpAuthHelperService,
    private httpHelperService: HttpHelperService
  ) {}

  async search(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/searchShops`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async editShop(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/editShop`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  // This method uses common/shops which is in excludedUrls (no auth required)
  async getShops(data: { unitId: string }): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}common/shops/${data.unitId}`
      );
    } catch (error) {
      throw error;
    }
  }

  async createShop(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/createShop`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async createPwc(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/createPwc`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async deletePwc(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/deletePwc`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async deleteShop(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/deleteShop`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async getPwcsByUnit(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/retrieveApprovedPwcsFromUnit`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async switchPwc(data?: any): Promise<any> {
    try {
      return await this.httpAuthHelperService.requestPromise(
        'POST',
        `${this.baseUrl}shops/switchPwc`,
        data
      );
    } catch (error) {
      throw error;
    }
  }
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
